import React from 'react'
import PropTypes from 'prop-types'
import YoutubePlayer from './YoutubePlayer'

const Text = ({
  content,
  style,
  settings,
  currentLang,
  renderElement,
}) => (
  renderElement(
    YoutubePlayer,
    {
      style,
      settings,
      content
    },
  )
)

Text.propTypes = {}
Text.defaultProps = {}

export default Text



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/youtube/Youtube.js